export const PermissionTypes = {
    MODIFY_REVIEW_TEMPLATES: 'modify_review_templates',
    READ: 'read',
    WRITE: 'write',
    VIEW_SALARY_INFO: 'view_salary_information',
    EDIT_SALARY_INFO: 'edit_salary_information',
    WRITE_REVIEW_TEMPLATES: 'write_review_templates',
    READ_ALL_REVIEWS: 'read_all_reviews',
    READ_AND_WRITE_ALL_REVIEWS: 'read_and_write_all_reviews',
    READ_AND_WRITE_OWN_REVIEW: 'read_and_write_own_review',
    READ_AND_WRITE_REVIEWS_FOR_MANAGED_EMPLOYEES: 'read_and_write_reviews_for_managed_employees',
    READ_ALL_TIME_CLOCKS: 'read_all_time_clocks',
    READ_AND_WRITE_ALL_TIME_CLOCKS: 'read_and_write_all_time_clocks',
    READ_AND_WRITE_TIME_CLOCKS_FOR_MANAGED_EMPLOYEES: 'read_and_write_time_clocks_for_managed_employees'
};